import { createIconComponent } from '../../factory/create-icon-component';
export const FranceIcon = createIconComponent(
  'FranceIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28285)">
      <path d="M23 5H1V20H23V5Z" fill="#F0F0F0" />
      <path d="M8.33317 5H1V20H8.33317V5Z" fill="#0052B4" />
      <path d="M22.9998 5H15.6667V20H22.9998V5Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_4605_28285">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
